import Accordion from 'accordion-js';
import 'accordion-js/dist/accordion.min.css';
import { iziToastError } from "./izi-toast";
import { swiperFeedback, swiperPoppular } from "./swiper";

import { refs } from "./refs";
import { getAllItemsByQuery, getCategoriesByQuery, getItemsByQuery, getFeedback, getPopulatProduct } from "./products-api";
import { clearFurnitureList, renderCategories, renderFurnitureList, renderFeedback, renderPopularProducts } from "./render-function";
import { hideLoader, hideLoadMore, scrollByTop, showLoader, showLoadMore } from "./helpers";
import { openProductModal } from './modal-product';
import { deployThemeToggle } from './storage';

let query = "";
let page = 1;
let totalCounter;
export let allLaodProduct = [];
let isTopPage = true;

export async function initHomePage() {
    deployThemeToggle();

    getCategoriesByQuery().then(data => {
        renderCategories(data);
    })

    getAllItemsByQuery(page).then(data => {
        totalCounter = data.totalItems - data.furnitures.length;
        allLaodProduct.push(...data.furnitures);
        renderFurnitureList(data.furnitures);
        refs.furnitureList.addEventListener('click', onBtnDetalsProduct);
        hideLoader();
        showLoadMore();
    })

    try {
        const popularProducts = await getPopulatProduct();

        allLaodProduct.push(...popularProducts.furnitures);

        renderPopularProducts(popularProducts.furnitures);
        swiperPoppular();
        refs.popularSwiperBox.addEventListener('click', onBtnDetalsProduct);

    } catch (error) {
        iziToastError(error.message)
    }



    new Accordion('.accordion-container', {
        duration: 300,
        showMultiple: false,
    });

    try {
        const feedbacks = await getFeedback();
        renderFeedback(feedbacks);
        swiperFeedback();
    } catch (error) {
        iziToastError(error.message)
    }
}

export async function handleLoadMore(event) {
    hideLoadMore();
    showLoader();
    page++;
    refs.loadMoreBtn.blur();
    if (refs.allCategoriesBtn.classList.contains("accent")) {
        try {
            const response = await getAllItemsByQuery(page);
            allLaodProduct.push(...response.furnitures);
            renderFurnitureList(response.furnitures);
            refs.furnitureList.addEventListener('click', onBtnDetalsProduct);
            hideLoader();
            showLoadMore();
            totalCounter -= response.furnitures.length
            if (!totalCounter) {
                hideLoadMore();
            }

        } catch (error) {
            iziToastError(error.message)
        }
    } else {
        try {
            const response = await getItemsByQuery(query, page);
            allLaodProduct.push(...response.furnitures);
            renderFurnitureList(response.furnitures);
            refs.furnitureList.addEventListener('click', onBtnDetalsProduct);
            hideLoader();
            showLoadMore();
            totalCounter -= response.furnitures.length
            if (!totalCounter) {
                hideLoadMore();
            }

        } catch (error) {
            iziToastError(error.message)
        }
    }
}

export async function handleClick(event) {
    event.preventDefault();
    if (event.target === event.currentTarget) {
        return
    }
    clearFurnitureList();
    allLaodProduct = [];
    page = 1;
    showLoader();
    hideLoadMore();
    if (event.target.classList.contains('categories-btn')) {
        document.querySelectorAll('.categories-btn.accent').forEach(btn => {
            btn.classList.remove('accent');
        });
        event.target.classList.add('accent');
    }

    if (event.target !== event.currentTarget) {
        if (event.target.id === "all-categories") {
            try {
                const response = await getAllItemsByQuery(page);
                totalCounter = response.totalItems - response.furnitures.length;
                allLaodProduct.push(...response.furnitures);
                renderFurnitureList(response.furnitures);
                refs.furnitureList.addEventListener('click', onBtnDetalsProduct);
                hideLoader();
                showLoadMore();
            } catch (error) {
                iziToastError(error.message);
            }
        } else {
            query = event.target.id;

            try {
                const response = await getItemsByQuery(event.target.id, page);
                totalCounter = response.totalItems - response.furnitures.length;
                allLaodProduct.push(...response.furnitures);
                renderFurnitureList(response.furnitures);
                refs.furnitureList.addEventListener('click', onBtnDetalsProduct);
                hideLoader();
                showLoadMore();
                if (!totalCounter) {
                    hideLoadMore();
                }
            } catch (error) {
                iziToastError(error.message);
            }
        }
    }
}

function onBtnDetalsProduct(event) {

    if (!event.target.classList.contains('furniture-details-btn')
        && !event.target.classList.contains('popular-details-btn')) {
        return;
    }
    const idProduct = event.target.id;
    openProductModal(idProduct);
}

export function handlerScroll() {
    if (window.scrollY > 400 && isTopPage === true) {
        isTopPage = false;
        refs.scrollTopBtn.classList.add('scroll-top-btn--visible');
        refs.scrollTopBtn.addEventListener('click', scrollByTop);

    } else if (window.scrollY < 400 && isTopPage === false) {
        isTopPage = true;
        refs.scrollTopBtn.removeEventListener('click', scrollByTop);
        refs.scrollTopBtn.classList.remove('scroll-top-btn--visible');
    }
}
